/**
 * @param {Object} formData - The event triggered by the OnChange event of the react bootstrap form
 * @returns {string[]} - empty array if the form is valid or string array with the name of the invalid fields
 */
export default function (formData) {
    const errors = [];
    for (const key in formData) {
        if (formData[key] === null || formData[key] === undefined || formData[key] === '') {
            errors.push(key);
        }
    }
    return errors;
}
